import Cookies from 'js-cookie';

function SubscribeButton({ 
  id, 
  name,
  price, 
  content, 
  features, 
  handlerSubscribe, 
  handlerCancel ,
  disabled,
  featuresDescriptions
}) {
  const email = Cookies.get("email");
  const userId = Cookies.get("firebaseuid");

  return (
    <div className="subscribe-button d-flex flex-column justify-content-between">
      <div>
        <h1 className='subscribe-title'>{name}</h1>

        { price !== 0 && <p className='subscribe-price'>$ {price} <span>Tier</span></p>}

        { features &&
          <div>
            <ul className='subscribe-features'>
              {featuresDescriptions && featuresDescriptions.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        }

        { content && <div className='subscribe-content' dangerouslySetInnerHTML={{ __html: content }}></div> }
      </div>
      <div>
        { handlerSubscribe &&
          <button 
            type="button"
            className="subscribe-link"
            onClick={handlerSubscribe}
            disabled={disabled}
          >
            Subscribe
          </button>
        }
        
        { handlerCancel &&
          <button 
            type="button"
            className="subscribe-link"
            onClick={handlerCancel}
          >
            Cancel Subscription
          </button>
        }
      </div>

    </div>
  );
}

export default SubscribeButton;